"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleLink = exports.TitleIcon = exports.TitleArea = exports.Root = exports.ReportButton = exports.MobileTitleArea = exports.MediaContainer = exports.Content = exports.Actions = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _socialIcons = require("@ori-ui/social-icons");
var _constants = require("../../constants");
var _constants2 = require("./constants");
const Root = exports.Root = (0, _mui.styled)(_mui.ScopedCssBaseline)(({
  theme
}) => ({
  display: 'grid',
  boxSizing: 'border-box',
  gridTemplateColumns: '1fr',
  overflow: 'hidden',
  background: theme.palette.common.white,
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: '600fr 494fr'
  }
}));
const MediaContainer = exports.MediaContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  overflow: 'hidden',
  boxSizing: 'border-box',
  position: 'relative',
  gridTemplateColumns: '1fr',
  gridTemplateRows: '1fr',
  width: '100vw',
  height: '100vw',
  padding: theme.spacing(0, 3),
  [theme.breakpoints.between('sm', 'lg')]: {
    maxHeight: _constants2.DETAIL_ITEM_MOBILE_MAX_HEIGHT,
    justifyItems: 'center'
  },
  [theme.breakpoints.up('lg')]: {
    width: '100%',
    height: `calc((100vw - ${_constants.arrowsPlusGapsBig}px) * ${_constants.widthToHeightRatio})`,
    maxHeight: _constants.maxItemHeight,
    overflow: 'hidden',
    padding: 0
  }
}));
const Content = exports.Content = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  display: 'grid',
  boxSizing: 'border-box',
  [theme.breakpoints.up('lg')]: {
    gridTemplateRows: '50px auto 1fr',
    padding: theme.spacing(4, 2, 2, 6),
    height: `calc((100vw - ${_constants.arrowsPlusGapsBig}px) * ${_constants.widthToHeightRatio})`,
    maxHeight: _constants.maxItemHeight,
    width: '100%',
    maxWidth: 494,
    overflow: 'hidden'
  }
}));
const MobileTitleArea = exports.MobileTitleArea = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  gridTemplateColumns: `${_constants.arrowBig}px 1fr ${_constants.arrowBig}px`,
  padding: theme.spacing(0, 3)
}));
const TitleArea = exports.TitleArea = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  gridColumn: '2 / 3',
  [theme.breakpoints.up('lg')]: {
    gridColumn: 'unset',
    padding: theme.spacing(0, 4, 0, 0),
    overflow: 'hidden'
  }
}));
const TitleLink = exports.TitleLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  textDecoration: 'none',
  padding: theme.spacing(3, 1),
  maxWidth: 'calc(100vw - 80px)',
  overflow: 'hidden',
  [theme.breakpoints.up('lg')]: {
    padding: 0,
    maxWidth: 434
  }
}));
const TitleIcon = exports.TitleIcon = (0, _mui.styled)(_socialIcons.Instagram)(({
  theme
}) => ({
  fontSize: '200%',
  marginRight: theme.spacing(2)
}));
const Actions = exports.Actions = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignSelf: 'end',
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridTemplateRows: 'auto auto',
  gap: theme.spacing(4),
  paddingBottom: theme.spacing(3),
  [theme.breakpoints.up('lg')]: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 60,
    gridTemplateColumns: 'auto 160px',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 4),
    gap: theme.spacing(6),
    background: (0, _mui.alpha)(theme.palette.common.white, 0.95),
    zIndex: 1
  }
}));
const ReportButton = exports.ReportButton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  gridRow: '2 / 3',
  textTransform: 'none',
  width: 'max-content',
  justifySelf: 'center',
  [theme.breakpoints.up('lg')]: {
    gridRow: '1 / 2',
    textTransform: 'none'
  }
}));
